import { createReducer } from '@reduxjs/toolkit';

import {
  loadPayoutRouteListSuccess,
  loadPayoutRouteStart,
  loadPayoutRoutingListSuccess,
  loadPayoutRoutingStart,
  resetPayoutRouteItem,
} from './actions';
import { IPayoutRoutingReducer } from './types';

const initialState: IPayoutRoutingReducer = {
  routing: {
    isLoading: false,
    isLoaded: false,
    data: {},
  },
  route: {
    isLoading: false,
    isLoaded: false,
    data: {},
  },
};

const PayoutRoutingReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(loadPayoutRoutingStart, (state) => ({
      ...state,
      routing: {
        ...state.routing,
        isLoading: true,
      },
    }))
    .addCase(loadPayoutRoutingListSuccess, (state, action) => ({
      ...state,
      routing: {
        ...state.routing,
        isLoading: false,
        isLoaded: true,
        data: action.payload,
      },
    }))
    .addCase(loadPayoutRouteStart, (state) => ({
      ...state,
      route: {
        ...state.route,
        isLoading: true,
      },
    }))
    .addCase(loadPayoutRouteListSuccess, (state, action) => ({
      ...state,
      route: {
        ...state.route,
        isLoading: false,
        isLoaded: true,
        data: action.payload,
      },
    }))
    .addCase(resetPayoutRouteItem, (state) => ({
      ...state,
      route: {
        ...initialState.route,
      },
    }));
});

export default PayoutRoutingReducer;
